import { graphql } from '../graphql';

export const myProjectsQuery = graphql(`
  query MyProjects {
    projects {
      id
      name
      srid
      organizationId
      folderId
      storageUsedBytes
      archiveStatus
      archiveBytes
      retentionUntil
    }
  }
`);

export const archivedProjectsQuery = graphql(`
  query ArchivedProjects {
    archivedProjects {
      id
      name
      organizationId
      archiveStatus
      archivedAt
      archiveBytes
      archiveNonArchivedBytes
      retentionUntil
      restoreRequestedAt
      restoreRetrievedAt
      restoreExpiresAt
      archiveError
      storageUsedBytes
    }
  }
`);

export const archivePreviewQuery = graphql(`
  query ArchivePreview($projectId: ID!) {
    archivePreview(projectId: $projectId) {
      archivableBytes
      nonArchivableBytes
      archivableFileCount
      nonArchivableFileCount
      monthlyCostCurrent
      monthlyCostArchived
      retrievalFeeEstimate
      quotaAfterArchive
      retentionEndsAt
      blockingJobs {
        id
        type
        status
        label
      }
    }
  }
`);

export const getProjectQuery = graphql(`
  query GetProject($id: ID!) {
    project(id: $id) {
      id
      name
      description
      srid
      proj4String
      organizationId
      initialPosition
      initialAngle
      defaultThirdPersonView
      archiveStatus
      archiveBytes
      retentionUntil
      storageUsedBytes
      ephemeralBytes
      baseMaps {
        id
        name
        type
        url
        tileSize
        wmsVersion
        wmsLayers
        format
      }
    }
  }
`);

export const sharedLinkQuery = graphql(`
  query SharedLink {
    sharedLink {
      id
      allowQuickUploads
      expiresAt
      hasPassword
    }
  }
`);

export const getSharedProjectQuery = graphql(`
  query GetSharedProject {
    sharedProject {
      id
      name
      srid
      proj4String
      organizationId
      initialPosition
      initialAngle
      defaultThirdPersonView
      baseMaps {
        id
        name
        type
        url
        tileSize
        wmsVersion
        wmsLayers
        format
      }
      organization {
        name
        slug
        logo {
          url
        }
      }
    }
  }
`);

export const createProjectMutation = graphql(`
  mutation CreateProject($input: CreateProjectInput!) {
    createProject(input: $input) {
      id
      name
      srid
    }
  }
`);

export const getProjectJobsQuery = graphql(`
  query GetProjectJobs($projectId: ID!) {
    jobs(projectId: $projectId) {
      id
      type
      status
      inputJson
      outputJson
      logs
      errorLogs
      startedAt
      completedAt
      estimatedCompletion
      leaseUntil
      attempts
      isLeaf
      batchId
      parentItemId
      createdAt
      updatedAt
    }
  }
`);

export const getProjectJobsByBatchQuery = graphql(`
  query GetProjectJobsByBatch($batchId: ID!) {
    jobs: jobsByBatch(batchId: $batchId) {
      id
      type
      status
      inputJson
      outputJson
      logs
      errorLogs
      startedAt
      completedAt
      estimatedCompletion
      leaseUntil
      attempts
      isLeaf
      batchId
      parentItemId
      createdAt
      updatedAt
    }
  }
`);

export const getProjectLinksQuery = graphql(`
  query GetProjectLinks($projectId: ID!) {
    projectLinks(projectId: $projectId) {
      id
      projectId
      name
      token
      hasPassword
      expiresAt
      createdAt
      createdById
      status
      viewCount
      allowQuickUploads
      ephemeralBytes
      createdBy {
        id
        name
        email
        avatar {
          url
        }
      }
    }
  }
`);

export const getAllProjectLinksQuery = graphql(`
  query GetAllProjectLinks {
    allProjectLinks {
      id
      projectId
      project {
        id
        name
      }
      name
      token
      hasPassword
      expiresAt
      createdAt
      createdById
      status
      viewCount
      allowQuickUploads
      ephemeralBytes
      createdBy {
        id
        name
        email
        avatar {
          url
        }
      }
    }
  }
`);
